import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const customerProfileService = {
  get_all_profile: async (
    page = "1",
    limit = "10",
    token,
    search = "",
    from_date = "",
    to_date = "",
  ) => {
    const response = await https.get(
      `${API_ROUTES.PROFILE.GET_ALL_PROFILE}?page=${page}&limit=${limit}&search_value=${search}&from_date=${from_date}&to_date=${to_date}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  get_original_profiles: async (token, params = {}) => {
    const response = await https.get(
      API_ROUTES.PROFILE.GET_ALL_ORIGINAL_PROFILE,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      },
    );
    return response;
  },
  get_all: async (customerId, page = 1, limit = 10, token) => {
    const response = await https.get(
      `${API_ROUTES.SERVICE.GET_ALL_BY_CUSTOMERID}/${customerId}?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  get_list_request_profile: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.PROFILE.GET_LIST_REQUEST_PROFILE}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      },
    );
    return response;
  },
  get_request_profile_pending: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.PROFILE.GET_REQUEST_PROFILE_PENDING}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      },
    );
    return response;
  },
  get_estimate_adjustment_history: async (token, profileId, params) => {
    const response = await https.get(
      `${API_ROUTES.PROFILE.GET_ESTIMATE_ADJUSTMENT_HISTORY.replace(
        ":profileId",
        profileId,
      )}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      },
    );
    return response;
  },
  get_pending_adjustment: async (token, estimateId) => {
    const response = await https.get(
      `${API_ROUTES.PROFILE.GET_PENDING_ADJUSTMENT.replace(
        ":estimateId",
        estimateId,
      )}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  update_pending_adjustment: async (token, estimateId, data) => {
    const response = await https.patch(
      `${API_ROUTES.PROFILE.UPDATE_PENDING_ADJUSTMENT.replace(
        ":estimateId",
        estimateId,
      )}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  delete_pending_adjustment: async (token, estimateId, adjustmentId) => {
    const uri = API_ROUTES.PROFILE.DELETE_PENDING_ADJUSTMENT
      .replace(":estimateId", estimateId)
      .replace(":adjustmentId", adjustmentId);
    return https.delete(uri, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  delete_adjustment_history: async (token, estimateId, adjustmentId) => {
    const uri = API_ROUTES.PROFILE.DELETE_ADJUSTMENT_HISTORY
      .replace(":estimateId", estimateId)
      .replace(":adjustmentId", adjustmentId);
    return https.delete(uri, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  get_edit_history: async (profile_id, token) => {
    const response = await https.get(
      `${API_ROUTES.PROFILE.GET_EDIT_HISTORY}/${profile_id}/history`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  get_by_id: async (profile_id, token) => {
    const response = await https.get(
      `${API_ROUTES.PROFILE.GET_BY_ID}/${profile_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  get_profile_estimate: (token, profileId) => {
    const uri = API_ROUTES.PROFILE.GET_PROFILE_ESTIMATE.replace(
      ":profileId",
      profileId,
    );
    return https.get(uri, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  update_profile_estimate: (token, profileId, data) => {
    const uri = API_ROUTES.PROFILE.UPDATE_PROFILE_ESTIMATE.replace(
      ":profileId",
      profileId,
    );
    return https.patch(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  delete: async (profile_id, token) => {
    const response = await https.delete(
      `${API_ROUTES.PROFILE.DELETE}/${profile_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  create_service: async (profile_id, data, token) => {
    const response = await https.post(
      `${API_ROUTES.PROFILE.CREATE}/${profile_id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  edit_service: async (profile_id, data, token) => {
    const response = await https.put(
      `${API_ROUTES.PROFILE.UPDATE}/${profile_id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  get_detail: (profile_id, token) => {
    return https.get(`${API_ROUTES.PROFILE.GET_DETAIL}/${profile_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  update_general_profile: async (profile_id, data, token) => {
    return https.put(
      `${API_ROUTES.PROFILE.UPDATE_GENERAL_PROFILE}/${profile_id}/general`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  duplicate_profile: async (profile_id, token) => {
    const response = await https.post(
      `${API_ROUTES.PROFILE.DUPLICATE_PROFILE}/${profile_id}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
};
